import { FormInstance } from 'antd';
import useFormSubmittable from 'hooks/useFormSubmittable';
import { NouveauDossierConcessionnaireData } from 'types/Concessionnaire';

interface UseStep2SectionSubmittableArgs {
  form: FormInstance<NouveauDossierConcessionnaireData>;
  fields: (keyof NouveauDossierConcessionnaireData)[];
  enabled?: boolean;
}

export default function useStep2SectionSubmittable({
  form,
  fields,
  enabled = true,
}: UseStep2SectionSubmittableArgs): boolean {
  return useFormSubmittable(form, {
    fieldNames: fields as string[],
    enabled,
    initialSubmittable: false,
  });
}
